var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 76,
    viewBox: "0 0 160 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.538 38.7344C141.538 29.9901 137.299 23.0903 129.197 23.0903C121.06 23.0903 116.137 29.9901 116.137 38.6661C116.137 48.9474 121.949 54.1393 130.291 54.1393C134.359 54.1393 137.436 53.2171 139.761 51.9191V45.0876C137.436 46.249 134.769 46.9663 131.385 46.9663C128.068 46.9663 125.128 45.8049 124.752 41.7744H141.47C141.47 41.3303 141.538 39.5542 141.538 38.7344ZM124.65 35.4894C124.65 31.6297 127.009 30.0243 129.162 30.0243C131.248 30.0243 133.47 31.6297 133.47 35.4894H124.65Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.94 23.0903C99.5898 23.0903 97.4359 24.6616 96.2394 25.7546L95.7949 23.6369H88.2736V63.4643L96.8206 61.6539L96.8547 51.9874C98.0855 52.8755 99.8975 54.1393 102.906 54.1393C109.026 54.1393 114.598 49.2207 114.598 38.3928C114.564 28.4872 108.923 23.0903 102.94 23.0903ZM100.889 46.6247C98.8718 46.6247 97.6753 45.9074 96.8547 45.0193L96.8206 32.347C97.7095 31.3564 98.9402 30.6733 100.889 30.6733C104 30.6733 106.154 34.1573 106.154 38.6319C106.154 43.209 104.034 46.6247 100.889 46.6247Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5128 21.0751L85.094 19.2306V12.2966L76.5128 14.107V21.0751Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.094 23.671H76.5128V53.5587H85.094V23.671Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3163 26.1987L66.7693 23.671H59.3846V53.5587H67.9317V33.3034C69.9487 30.6733 73.3675 31.1515 74.4274 31.5272V23.671C73.3334 23.2611 69.3334 22.5097 67.3163 26.1987Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2223 16.2589L41.8804 18.0351L41.8462 45.3951C41.8462 50.4503 45.6411 54.1735 50.7009 54.1735C53.5043 54.1735 55.5556 53.6611 56.6838 53.0463V46.1124C55.5898 46.5564 50.1881 48.1276 50.1881 43.0724V30.9465H56.6838V23.671H50.1881L50.2223 16.2589Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1111 32.347C27.1111 31.0148 28.2051 30.5025 30.0171 30.5025C32.6154 30.5025 35.8974 31.2881 38.4957 32.6885V24.6616C35.6581 23.5344 32.8547 23.0903 30.0171 23.0903C23.0769 23.0903 18.4615 26.711 18.4615 32.7569C18.4615 42.1843 31.453 40.6813 31.453 44.7461C31.453 46.3173 30.0855 46.8297 28.1709 46.8297C25.3333 46.8297 21.7094 45.6683 18.8376 44.0971V52.2265C22.0171 53.5928 25.2308 54.1735 28.1709 54.1735C35.2821 54.1735 40.1709 50.6553 40.1709 44.5411C40.1368 34.3622 27.1111 36.1726 27.1111 32.347Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIcon);
export default __webpack_public_path__ + "static/media/stripe-icon.f6ab9e77e2330265a65991422bdb1da6.svg";
export { ForwardRef as ReactComponent };